import { render, staticRenderFns } from "./SendDocumentView.vue?vue&type=template&id=107e1d26&scoped=true&"
import script from "./SendDocumentView.vue?vue&type=script&lang=ts&"
export * from "./SendDocumentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107e1d26",
  null
  
)

export default component.exports